import { useQuery } from "@tanstack/react-query";
import type { LeadVisit, VisitEventDto } from "@school-sales-ai/shared";
import { api } from "@/lib/api";

// Keyed under ["lead", leadId, ...] so the per-turn invalidation in
// useTestAgent (and any future lead-detail invalidation) refreshes it too.
export function useLeadVisit(leadId: string) {
  return useQuery({
    queryKey: ["lead", leadId, "visit"],
    queryFn: () => api.get<{ visit: LeadVisit | null }>(`/crm/leads/${leadId}/visit`),
    enabled: !!leadId,
  });
}

export function useLeadVisitEvents(leadId: string) {
  return useQuery({
    queryKey: ["lead", leadId, "visit-events"],
    queryFn: () =>
      api.get<{ events: VisitEventDto[] }>(`/crm/leads/${leadId}/visit-events`),
    enabled: !!leadId,
  });
}
